// Styles for CompareButton go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
export const StyledCompareButton = styled.div`
  .compare-button {
    border-radius: ${toRem(52)};
  }
`;
